/* global analytics */

export type Method =
  | 'email'
  | 'facebook'
  | 'link'
  | 'messenger'
  | 'sms'
  | 'twitter'
  | 'whatsapp'

type Source =
  | 'adventure_page'
  | 'bucket_list'
  | 'listing_page'
  | 'story_page'
  | 'itinerary_builder'
  | 'booking_confirmation_page'

export const trackPageShared = ({
  method,
  source,
  url,
}: {
  method: Method
  source: Source
  url: string
}) => {
  analytics.track('Page Shared', {
    method,
    source,
    url,
  })
}
